export interface Conference {
  name: string;
  category: string;
  description: string;
  images?: string[];
  additionalInfo?: string;
}

export const konferensiInternasionalData: Conference[] = [
  // ASEANAPOL Activities
  {
    name: "ASEANAPOL Training Cooperation Meeting (ATCM)",
    category: "ASEANAPOL",
    description:
      "ATCM merupakan pertemuan rutin antar negara-negara ASEAN yang berfokus kepada kerja sama pelatihan kepolisian. Kegiatan ini bertujuan untuk merencanakan, mengoordinasikan, dan meningkatkan pelatihan bersama di bidang hukum.",
    images: [
      "/konferensi-internasional/1. ASEANAPOL Training Cooperation Meeting (ATCM).png",
    ],
  },
  {
    name: "ASEANAPOL Database System Technical Committee (ADSTC)",
    category: "ASEANAPOL",
    description:
      "ADSTC merupakan forum teknis dibawah ASEANAPOL yang bertugas dalam mengelola dan mengembangkan sistem basis data bersama antar kepolisian negara ASEAN. Kegiatan ini pertemuan rutin untuk membahas pemeliharaan, pembaruan, dan keamanan ASEANAPOL Database System, serta peningkatan fitur untuk mendukung pertukaran informasi kriminal lintas batas negara.",
    images: [
      "/konferensi-internasional/2. ASEANAPOL Database System Technical Committee (ADSTC).png",
    ],
  },
  {
    name: "ASEANAPOL Contact Person Meeting (ACPM)",
    category: "ASEANAPOL",
    description:
      "ACPM merupakan pertemuan rutin para perwakilan kepolisian dari negara-negara anggota ASEANAPOL. Kegiatan ini bertujuan untuk memperkuat komunikasi dan koordinasi antar negara anggota, memfasilitasi pertukaran informasi terkait kejahatan lintas negara, dan membahas tindak lanjut kerja sama yang telah disepakati.",
    images: [
      "/konferensi-internasional/3. ASEANAPOL Contact Person Meeting (ACPM).png",
    ],
  },
  {
    name: "ASEAN Ministerial Meeting on Transnational Crime (AMMTC)",
    category: "ASEAN",
    description:
      "AMMTC merupakan pertemuan para menteri dalam negeri atau pejabat tinggi setingkat dari negara-negara ASEAN yang membahas penanggulangan kejahatan transnasional. Kegiatannya meliputi merumuskan kebijakan bersama, mengadopsi rencana aksi, memperkuat kerja sama, koordinasi antar negara anggota, serta memantau perkembangan dan tantangan kejahatan lintas negara seperti terorisme, perdagangan orang, narkotika, kejahatan siber, dan pencucian uang.",
    images: [
      "/konferensi-internasional/4. ASEAN Ministerial Meeting on Transnational Crime (AMMTC).png",
    ],
  },
  {
    name: "ASEAN Senior Officials Meeting on Transnational Crime (SOMTC)",
    category: "ASEAN",
    description:
      "ASEAN SOMTC merupakan pertemuan pejabat tinggi dari negara-negara ASEAN yang bertugas mempersiapkan dan mengoordinasikan implementasi kebijakan penanggulangan kejahatan transnasional.",
    images: [
      "/konferensi-internasional/5. ASEAN Senior Officials Meeting on Transnational Crime (SOMTC).png",
    ],
  },
  // Working Groups
  {
    name: "Working Group on Arms Smuggling",
    category: "Working Group",
    description:
      "Working Group on Arms Smuggling adalah kelompok kerja di bawah kerangka ASEAN yang fokus pada penanggulangan penyelundupan senjata api di kawasan.",
    images: [
      "/konferensi-internasional/6. Working Group on Arms Smuggling.png",
    ],
  },
  {
    name: "Working Group on Counter Terrorism",
    category: "Working Group",
    description:
      "Working Group on Counter Terrorism adalah kelompok kerja ASEAN yang menangani isu penanggulangan terorisme di kawasan.",
    images: [
      "/konferensi-internasional/7. Working Group on Counter Terrorism.png",
    ],
  },
  {
    name: "Working Group on Trafficking in Person",
    category: "Working Group",
    description:
      "Working Group on Trafficking in Persons adalah kelompok kerja ASEAN yang berfokus pada penanggulangan perdagangan orang di kawasan.",
    images: [
      "/konferensi-internasional/8. Working Group on Trafficking in Person.png",
    ],
  },
  {
    name: "Working Group on Cyber Crime",
    category: "Working Group",
    description:
      "Working Group on Cyber Crime adalah kelompok kerja ASEAN yang fokus pada penanggulangan kejahatan siber di kawasan.",
    images: ["/konferensi-internasional/9. Working Group on Cyber Crime.png"],
  },
  {
    name: "Working Group on Illicit Trafficking of Wildlife and Timber (ITWT)",
    category: "Working Group",
    description:
      "Working Group on Illicit Trafficking of Wildlife and Timber adalah kelompok kerja ASEAN yang berfokus pada penanggulangan perdagangan ilegal satwa liar dan kayu.",
    images: [
      "/konferensi-internasional/10. Working Group on Illicit Trafficking of Wildlife and Timber (ITWT);.png",
    ],
  },
  {
    name: "Working Group on People Smuggling",
    category: "Working Group",
    description:
      "Working Group on People Smuggling adalah kelompok kerja ASEAN yang menangani isu penyelundupan manusia di kawasan.",
    images: [
      "/konferensi-internasional/11. Working Group on People Smuggling.png",
    ],
  },
  {
    name: "Working Group on General Transnational Crime Matter",
    category: "Working Group",
    description:
      "Working Group on General Transnational Crime Matter adalah kelompok kerja ASEAN yang membahas isu-isu kejahatan transnasional yang bersifat umum.",
    images: [
      "/konferensi-internasional/12. Working Group on General Transnational Crime Matter.png",
    ],
  },
  {
    name: "Heads of Special Unit on Trafficking in Persons",
    category: "Working Group",
    description:
      "Heads of Special Unit on Trafficking in Persons adalah pertemuan para kepala unit khusus penanganan perdagangan orang dari negara-negara ASEAN.",
    images: [
      "/konferensi-internasional/13. Heads of Special Unit on Trafficking in Persons.png",
    ],
  },
];

export const conferenceCategories = [
  {
    name: "ASEANAPOL",
    description: "Kegiatan-kegiatan di bawah koordinasi ASEANAPOL",
    color: "text-primary",
  },
  {
    name: "ASEAN",
    description: "Pertemuan tingkat menteri dan pejabat tinggi ASEAN",
    color: "text-secondary",
  },
  {
    name: "Working Group",
    description: "Kelompok kerja tematik ASEAN",
    color: "text-accent",
  },
];
